/*
  core-js and regenerator-runtime should be included via .babelrc
  https://babeljs.io/docs/en/babel-preset-env

  [
    "@babel/preset-env", {
      "useBuiltIns": "usage", << should read from .browserslistrc
      "corejs": 3 << and inclucde all the core-js stuff for those browsers
                     including regenerator-runtime
    }
  ]

*/

//Trim right is needed for storybook component iframe links to work in IE
// import "core-js/features/string/trim-right.js";

// window.fetch
import "whatwg-fetch";

import "./closest.js"; // used in Popup.jsx (maybe elsewhere)

import "./popstate-event.js";

import "classlist-polyfill";

import "element-remove";

import "objectFitPolyfill";
window.objectFitPolyfill();

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// NodeList forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Jonathan 10-2019 - this was missing for some reason.  I'm adding it, but leaving it commented out.
// Note: object-fit has been refactored to be applied on-demand instead of automatically
// You may invoke it directly in your scripts
// import { objectFitPolyfill } from "./object-fit.js";
// if ("objectFit" in document.documentElement.style === false) {
//   objectFitPolyfill();
// }

import svg4everybody from "svg4everybody";
svg4everybody();
